class AddBuilding {
    constructor() {
        this.containers = []
    }
    addBuilding(config) {
        const { polygon } = this.getById(config.id)
        if (polygon) {
            this.setShowById(config.id, true)
        } else {
            let pol
            if (config.heightPropName === 0) {
                pol = new map3d.Vector.GroundBigJson(config)
            } else {
                pol = new map3d.Vector.BigJson(config)
            }
            pol.id = config.id
            this.containers.push(pol)
            return pol
        }
    }
    getById(id) {
        let result
        let index
        this.containers.forEach((item, i) => {
            if (item.id === id) {
                result = item
                index = i
            }
        })
        return {
            polygon: result,
            index: index
        }
    }
    getPropsByInnerId(id) {
        let result
        this.containers.forEach((item) => {
            result = item.selectFromMetaDate(id)
        })
        return result
    }
    setShowById(id, show) {
        const { polygon } = this.getById(id)
        polygon.setShowAll(show)
    }
    removeById(id) {
        const { polygon, index } = this.getById(id)
        this.containers.splice(index, 1)
        polygon.end()
    }
    setShowAll(show) {
        this.containers.forEach((item) => {
            item.setShowAll(show)
        })
    }
}
export default new AddBuilding()






// WEBPACK FOOTER //
// ./src/mapfunction/AddBuilding.js